import * as z from 'zod';

export const assessmentCreationSchema = z.object({
  selectedAssessmentType: z.object({ id: z.string(), label: z.string() }),
  selectedContactId: z.string(),
});
